import { TextField, TextFieldProps } from "@mui/material";
import { FieldProps, getIn } from "formik";
import React, { ChangeEvent } from "react";
import { Base } from "../base";

interface Props {}

const FormikTextField: React.FC<FieldProps & TextFieldProps & Props> = (
  props
) => {
  const {
    error,
    field,
    helperText,
    form,
    variant,
    margin,
    required,
    label,
    onChange,
    ...rest
  } = props;

  const isTouched = getIn(form.touched, field.name);
  const errorMessage = getIn(form.errors, field.name);

  const handleChange = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    field.onChange(event);
    onChange?.(event);
  };

  return (
    <TextField
      {...field}
      error={error ?? Boolean(isTouched && errorMessage)}
      fullWidth
      label={label}
      required={required}
      autoComplete="off"
      helperText={
        helperText ?? (isTouched && errorMessage) ? (
          <Base.Text text={errorMessage} variant="subtitle1" component="span" />
        ) : (
          " "
        )
      }
      onChange={handleChange}
      {...rest}
    />
  );
};

export default FormikTextField;
